export const shape = {
    eventType: 'eventType',
    page: 'page',
    section: 'section',
    component: 'component',
    action: 'action',
    elementType: 'elementType',
    elementName: 'elementName',
    userId: 'userId',
    selectedTenantId: 'selectedTenantId'
  };